// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_password-module__container--2784c","button":"switch_password-module__button--T1P5j"};